<template>
  <ul>
    <li v-for="(text, key) in question.question" :key="key">
      <button @click="cancel">No</button>
      <span>{{ text }}</span>
      <button @click="confirmKey(key)">Yes</button>
    </li>
  </ul>
</template>

<script>
import QuestionMixin from './QuestionMixin';

export default {
  name: '',

  mixins: [QuestionMixin],

  methods: {
    async cancel() {
      await this.$http.delete('/survey/logout');
      this.$router.push({ name: 'survey' });
    },

    confirmKey(key) {
      if (typeof this.answer !== 'object') {
        this.answer = {};
      }

      this.answer[key] = true;

      // If yes to all of the answers fire off the input event.
      const alen = Object.values(this.answer).length;
      const qlen = Object.values(this.question.question).length;

      if (alen === qlen) {
        this.$emit('input', this.answer);
      }
    },
  },
};
</script>
